import React, { FC } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LocationDot: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faLocationDot} {...props} />
);
